import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Shortcuts = props => {
  return (
    <SvgIcon {...props} width="24.636" height="30.896" viewBox="0 0 24.636 30.896">
      <g transform="translate(-5 -2)">
        <g transform="translate(5 2)">
          <path
            fillRule="evenodd"
            d="M17.917,9.808a4.794,4.794,0,1,0-7.458,0V6.785a3.729,3.729,0,0,1,7.458,0V9.808ZM20.579,31.83a8.151,8.151,0,0,0,7.992-7.99h0V17.45a1.6,1.6,0,1,0-3.2,0v.531H24.309V15.324a1.6,1.6,0,1,0-3.2,0v1.591H20.048V14.259a1.6,1.6,0,1,0-3.2,0V17.98H15.786V6.8a1.6,1.6,0,1,0-3.2,0V18.833C10.4,16.488,7.51,13.91,6.327,15.1c-1.158,1.164,1.826,4.373,5.994,11.386,1.878,3.16,4.254,5.344,8.258,5.345Zm9.057-7.99A9.056,9.056,0,0,1,20.58,32.9c-3.316,0-6.816-1.547-9.225-5.936C7.878,20.625,3.432,16.471,5.549,14.354c1.515-1.515,3.893-.062,5.975,1.887h0V6.8a2.663,2.663,0,1,1,5.327,0v5.316a2.669,2.669,0,0,1,4.1,1.2,2.661,2.661,0,0,1,4.426,1.992v.014a2.667,2.667,0,0,1,4.261,2.134V23.84Z"
            transform="translate(-5 -2)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default Shortcuts;
